import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import { Button, DefaultPopup } from '@atlas/ui';

import { MODAL_ROOT_NODE_ID } from 'src/common/ModalPortal/ModalPortal';
import PaymentMethodItem from 'src/components/ClientProfile/Payment/Deposit/PaymentMethodItem';

const QuickDepositPaymentMethodsPopup = ({
  depositBonuses,
  handleClose,
  handleSavePaymentMethod,
  paymentMethod,
  paymentMethods,
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(paymentMethod);

  return ReactDOM.createPortal(
    <DefaultPopup
      className="quick-deposit-payment-methods-popup"
      headerTitle="choose_payment_method"
      onClose={handleClose}
    >
      <div className="quick-deposit-payment-methods-list">
        {paymentMethods.map(paymentMethodItem => (
          <PaymentMethodItem
            className={selectedPaymentMethod.id === paymentMethodItem.id ? 'active' : ''}
            depositBonuses={depositBonuses}
            handleClick={() => {
              setSelectedPaymentMethod(paymentMethodItem);
            }}
            key={paymentMethodItem.id}
            paymentMethod={paymentMethodItem}
          />
        ))}
      </div>
      <div className="quick-deposit-payment-methods-button">
        <Button
          label="save"
          onClick={() => handleSavePaymentMethod(selectedPaymentMethod)}
          size="big"
        />
      </div>
    </DefaultPopup>,
    document.getElementById(MODAL_ROOT_NODE_ID),
  );
};

export default QuickDepositPaymentMethodsPopup;
